import React from "react";
import { Link } from "react-router-dom";
import { Card, Col, Row } from "react-bootstrap";
import "./Gallery.css";

import Floats from "../../home/home components/Floats";
import Footer from "../../home/home components/Footer";
import NavBar from "../../home/home components/NavBar";

// Import images
import {
  abvpImages,
  AnnualDayImages,
  birthdayImages,
  childrensDayImages,
  dahiHandiImages,
  fresherImages,
  HindiDiwasImages,
  RajotsavaImages,
  rakshaImages,
  saraImages,
  teacherdayImages,
  worldImages,
  yogaImages,
  independenceDayImages,
  raceImages,
  PrinciGroupImages,
  ganeshImages,
  GandhiShastreeImages,
  KuvempuImages,
  VivekanadaImages,
  VasanthPanchamiImages,
  VijayavaniExpoImages,
  RepublicDayImages,
  martiyersDayImages,
  hallTicketDistributionImages
} from "./Galleryphotos";

const Gallery = () => {

  const events = [
     { title: "Practical Exam Hall Ticket Distribution Day", images: hallTicketDistributionImages },
     { title: "Vijayavani Expo", images: VijayavaniExpoImages },
     { title: "Republic Day", images: RepublicDayImages },
     { title: "Martyrs' Day", images: martiyersDayImages },
     { title: "Vasanth Panchami", images: VasanthPanchamiImages },
     { title: "Vivekananda Jayanti", images: VivekanadaImages },
     { title: "Kuvempu Birthday", images: KuvempuImages },
     { title: "Children's Day Celebration", images: childrensDayImages },
     { title: "Karnataka Rajyotsava", images: RajotsavaImages },
     { title: "Gandhi & Shastree Jayanti", images: GandhiShastreeImages },
     { title: "Hindi Diwas", images: HindiDiwasImages },
     { title: "Teachers Day Celebration", images: teacherdayImages },
     { title: "Ganesh Chaturthi", images: ganeshImages },
     { title: "Independence Day", images: independenceDayImages },
     { title: "Raksha Bandan", images: rakshaImages },
     { title: "Sanganabasava Swamiji Birthday", images: birthdayImages },
    { title: "Group photos", images: PrinciGroupImages },
    { title: "Annual Day Celebration", images: AnnualDayImages},
    { title: "Dahi Handi Competition", images: dahiHandiImages },
    { title: "Cross Country Race", images: raceImages },
    { title: "ABVP Program", images: abvpImages },
    { title: "Freshers Day", images: fresherImages },
    { title: "World Environment Day", images: worldImages },
    { title: "Saraswati Pooja & Orientation Program", images: saraImages },
    { title: "Yoga Day", images: yogaImages },
   
    ];

  return (
    <>
      <NavBar />

      {/* Breadcrumb */}
      <section className="breadcrumbs">
        <div className="container">
          <ol>
            <li><Link to="/">Home</Link></li>
            <li>Media</li>
          </ol>
          <h2>Gallery</h2>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="portfolio">
        <div className="container">

          <Card className="text-center mb-4 shadow-sm">
            <Card.Header>
              <h4 className="mb-0">Gallery</h4>
            </Card.Header>
          </Card>

          {events.map((event, index) => (
            <div key={index}>

              <h3 className="text-center mt-5 mb-4 fw-bold">
                {event.title}
              </h3>

              <Row xs={1} sm={2} md={3} lg={4} className="g-4">

                {event.images.map((card) => (
                  <Col key={card.id}>

                    <Card className="h-100 shadow-sm gallery-card">

                      <Card.Img
                        variant="top"
                        src={card.image}
                        alt={event.title}
                        loading="lazy"
                        className="gallery-img"
                      />

                    </Card>

                  </Col>
                ))}

              </Row>

            </div>
          ))}

        </div>
      </section>

      <Footer />
      <Floats />

    </>
  );
};

export default Gallery;